import { Component, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  constructor(private services:ServiceStock, private translateService:TranslateService) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    this.services.updateScreenHeight();
  }

  callPhone(phone:string){
    let tel = "tel: " + this.translateService.instant(phone);
    window.open(tel, '_system');
  }

  openMail(mailid:string){
    let mail = "mailto:" + this.translateService.instant(mailid);
    window.open(mail, '_system');
  }

  openLink(url:string){
    let link = this.translateService.instant(url);
    window.open(link, '_system');
  }

}
